import { Link } from "@material-ui/core";
import styled, { css } from "styled-components";
import { TextContent } from "js/Components/TextContent";

export const CheckoutSwitchLink = styled(Link)`
    &&& {
        text-decoration: underline;
        color: #11a9e2;
        cursor: pointer;
    }
`;

export const SummaryContent = styled.div<{ $useMobileLayout?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    ${props => props.$useMobileLayout && css`
        gap: 0px;
        padding: 20px 30px;
        background: #F7FAFC;
        box-shadow: 0 -2px 25px 0 rgba(0, 0, 0, 0.08);
    `}
`;

export const SummaryBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SummaryTitle = styled.div`
    font-family: "Source Sans Pro";
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #222;
`;

export const TeamPlanInternal = styled(TextContent)`
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    color: #222;
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;

export const SeatsContainer = styled.div<{ $useMobileLayout?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 6px;
    ${props => props.$useMobileLayout && css`
        flex-direction: row;
        justify-content: space-between;
    `}
`;

export const PromoContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const SummarySection = styled.div<{ $useMobileLayout?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    ${props => props.$useMobileLayout && css`
        gap: 0px;
    `}
`;

export const ErrorMessageContainer = styled.div`
    color: red;
    font-size: 12px;
    margin-top: 10px;
`;

// Desktop-only styles
export const SummaryCard = styled.div`
    background: #f7fafc;
    border: 1px solid #dae9f0;
    border-radius: 2px;
    padding: 20px;
    width: 100%;
    max-width: 280px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
`;

export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
    min-height: 0;
    flex: 1 1 auto;
    padding: 15px 30px 0 30px;
`;

export const LeftForm = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1 1 auto;
`;

export const LeftFooter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-shrink: 0;
`;

export const CheckoutContentScroll = styled.div`
    flex: 1 1 0;
    min-height: 0;
    overflow-y: auto;
`;

// Mobile-only styles
export const MobileFormSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 40px 30px 0 30px;
    flex: 1 1 0;
    min-height: 0;
    overflow-y: auto;
`;

export const MobileSummarySection = styled.div`
    flex-shrink: 0;
    width: 100%;
`;
